import moment from 'moment';
export default function isDateValidWithDashes(value) {
    return moment(value, 'YYYY-MM-DD', true).isValid();
}
